export class RingBuffer<T> {
    private readonly buf: Array<T | undefined>;
    private start = 0;
    private length = 0;

    constructor(private readonly capacity: number) {
        if (!Number.isInteger(capacity) || capacity < 2) {
            throw new Error('RingBuffer capacity must be an integer >= 2');
        }
        this.buf = new Array<T | undefined>(capacity);
    }

    push(value: T): void {
        if (this.length < this.capacity) {
            this.buf[(this.start + this.length) % this.capacity] = value;
            this.length += 1;
            return;
        }

        this.buf[this.start] = value;
        this.start = (this.start + 1) % this.capacity;
    }

    clear(): void {
        this.start = 0;
        this.length = 0;
        this.buf.fill(undefined);
    }

    size(): number {
        return this.length;
    }

    isEmpty(): boolean {
        return this.length === 0;
    }

    at(index: number): T | undefined {
        if (index < 0 || index >= this.length) return undefined;
        return this.buf[(this.start + index) % this.capacity];
    }

    toArray(): T[] {
        const out: T[] = [];
        for (let i = 0; i < this.length; i += 1) {
            const value = this.buf[(this.start + i) % this.capacity];
            if (value !== undefined) out.push(value);
        }
        return out;
    }
}
